var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.toggle()}}},[_vm._v(_vm._s(_vm.label)+"\n"),_c('i',{staticClass:"fa",class:_vm.iconClass})])}
var staticRenderFns = []

export { render, staticRenderFns }